import React from 'react';
import { Typography, Box, Button } from '@material-ui/core';
import ImageBanner from './ImageBanner';
import items from '../../pages/membersupport/supportItems.json';
import ChatBubble from '@mui/icons-material/ChatBubble';
import { analyticsTrackClickEvent } from '../../../utils/analytics/analytics-utils';
// import { getEnvVars } from '../../../utils/env-utils';
import { useNavigate } from 'react-router-dom';
import { PathNames } from '../../../constants/AppConstants';
import '../../pages/membersupport/livesupport.css';
import Label from '../type/Label';
const MoreSupport = () => {
  const navigate = useNavigate();
 
  const handleItemClick = (title, type) => {
    navigate({
      pathname: PathNames.liveChatSupport,
      search: `?topic=${title}&chatType=${type}`
    });
  };

  return (
    <div>
      <ImageBanner title={<Label id='supportText'/>}></ImageBanner>
      <div className="memberSupportBox">
        <div className="memberSupportBox-Header">
        <Typography variant='h4' gutterBottom> <Label id="support" /></Typography>
        </div>
        <Box className="membersupportBox">
          {items.map((item, index) => (
            <div id="support-member-card" key={index}>
              <div className="member-support-details">
                <Typography className="support-topic"><Label id={item.chatType}/></Typography>
                <Typography variant="body1" className="moreSupportContact">
                  Call {item.phoneNumber}
                </Typography>
              </div>
              <Button
                variant="outlined"
                id="livechat"
                startIcon={<ChatBubble />}
                onClick={e => {
                  e.preventDefault();
                  handleItemClick(item.title, item.chatType);
                  analyticsTrackClickEvent('support_livechat_clicked', {
                    eventCategory: 'Support Pathing'
                  });
                }}
              >
                <Label id="livechat"/>
              </Button>
            </div>
          ))}
        </Box>
      </div>
    </div>
  );
};

export default MoreSupport;
